/**
 * <DockBody />
 *
 * IMPORTANT: This component takes props from react-confirm
 *
 * This component is also shared by ../UpdateLesson
 *
 * - Tell me about what this dock does...
 *
 * @parent anybody
 * @children
 * @stateless
 */
import React, { PropTypes } from 'react';
import classnames from 'classnames'
//
import { Dock } from 'components/UI';
import { confirmable } from 'react-confirm';
import { Provider } from 'react-redux'
import store from 'root/store';

import getAllClass from 'controllers/class/getAllClass'
import EditLessonForm from 'template/Forms/EditLesson'
import getClassTeacherStudent from 'controllers/class/getClassTeacherStudent';
import getLessonStudentList from 'controllers/lesson/getLessonStudentList';
import Lesson from 'mediators/Lesson';

import { SearchList } from 'components/UI'

import locale from './locale';

import filter from 'lodash/filter';

import './style.scss';

import ClassDetail from 'mediators/ClassDetail'

export const CREATE = 'CREATE';
export const UPDATE = 'UPDATE';

import Loading from 'components/UI/Loading';

class DockBody extends React.Component {
  static propTypes = {
    // if set false, it will not choose class
    chooseClass: PropTypes.bool,
    classDetail: PropTypes.instanceOf(ClassDetail),
  }

  constructor(props) {
    super(props);

    this._renderChooseClass = this._renderChooseClass.bind(this);
    this._onSelectClass = this._onSelectClass.bind(this);
    this._reselectClass = this._reselectClass.bind(this);
    this.loadClassDetail = this.loadClassDetail.bind(this);
    this.afterSubmit = this.afterSubmit.bind(this);
    this.loadLessonStudentList = this.loadLessonStudentList.bind(this);

    const {
      classDetail,
      lesson,
    } = props;

    this.state = {
      classDetail,
      lesson,
    }
  }

  afterSubmit(data) {
    this.props.proceed(data);
  }

  componentWillReceiveProps({ classDetail, lesson }) {
    if (classDetail) {
      this.setState({
        classDetail,
      });
    }

    if (lesson) {
      this.setState({
        lesson,
      });
    }
  }

  componentWillMount() {
    const { classId, classDetail, mode } = this.props;

    const { lesson } = this.state;

    if (!classDetail && mode == UPDATE) {
      this.loadClassDetail(classId);
    }

    //
    // if the student list is empty we need to get student List
    //
    if (lesson && !lesson.studentList) {
      this.loadLessonStudentList(lesson.id)
    }
  }

  _onSelectClass(classDetailArr) {
    const classSelected = classDetailArr[0];

    this.loadClassDetail(classSelected.id);
  }

  //
  // load studentList onto list
  //
  loadLessonStudentList(lessonId) {
    const { mode } = this.props;

    this.setState({
      fetchingStudentList: true,
    }, ()=>{
      getLessonStudentList(lessonId)
        .then(({student_list})=>{
          let lesson = this.state.lesson.toObject();

          if (mode === CREATE) {
            lesson.studentList = filter(student_list || [], (student)=>{
              return student.already_been_in_lesson === true;
            });
          } else {
            lesson.studentList = student_list;
          }

          this.setState({
            lesson: new Lesson(lesson),
            fetchingStudentList: false,
          });
        });

    });


  }

  loadClassDetail(classId) {
    this.setState({
      fetchingClassInfo: true,
    });

    getClassTeacherStudent(classId)
      .then((classDetail)=>{
        this.setState({
          classDetail,
          fetchingClassInfo: false,
        });
      })
      .catch((err)=>{
        console.error(err);
      });

  }

  _reselectClass() {
    this.setState({
      classDetail: undefined,
    });
  }

  render() {
    const {
      isVisible,
      show,
      dismiss,
      mode,
      chooseClass,
    } = this.props;

    const {
      classDetail,
      lesson,
      fetchingClassInfo,
      fetchingStudentList,
      loading,
    } = this.state;

    let dockTitle;

    if (chooseClass !== false) {
      if (!classDetail) {
        dockTitle = <a>{__('Class', 'schedule')}</a>;
      } else {
        if (mode === CREATE) {
          dockTitle = <a onClick={this._reselectClass}><i className='fa icon-angle-left'></i>{'  ' + __('Search Class', 'schedule')}</a>
        }
      }
    }

    if (mode === UPDATE) {
      dockTitle = __('Edit Lesson', locale);
    }

    const stillLoading = loading === true || fetchingStudentList === true || fetchingClassInfo === true;

    return (
      <Provider store={store}>
        <Dock
          className='add-lesson-dock'
          dockTitle={dockTitle}
          position='right'
          isVisible={show}
          size={0.28}
          onCloseDockClick={()=>{
            dismiss();
          }}
          useDefaultCloseButton={true}
        >
          { stillLoading && <Loading /> }
          <div className='dock-content'>
            { !classDetail && stillLoading !== true && chooseClass !== false &&
            <div className='class-list'>{this._renderChooseClass()}</div> }
            { classDetail && stillLoading !== true && this._renderLessonForm() }
          </div>
        </Dock>
      </Provider>
    )
  }

  _renderChooseClass() {
    const {
      disablePrivateClass,
      disableClass,
    } = this.props;

    const schoolId = localStorage.getItem('schoolId');

    const opts = {
      itemName: '',
      searchPlaceholder: __('Search Class', 'schedule'),
      itemList: [],
      selected: [],
      getItemLabel: (item)=>{
        return item.name;
      },
      fetchItems: (cb)=>{
        getAllClass(schoolId)
          .then((data)=>{
          let classList = [];
          (data['class list'] || []).map((cls)=>{
            let add = true;
            if (cls.cType == 1 && disablePrivateClass) {
              add = false;
            }
            if (cls.cType == 0 && disableClass) {
              add = false;
            }

            if (add) {
              classList.push(new ClassDetail(cls));
            }
          })
          cb(classList); // the default must be an empty array
        })
        .catch((err)=>{ console.error(err); });
      },
      isSelectedSortable: false,
      components: {
        SelectItem: ({item, getItemLabel, selected, onClickSelect, selectText, selectedText}) => {

          return (
            <div className='select-item' onClick={onClickSelect}>
              <div className='class-icon'>
                { item.type === 0 && <i className='fa icon-users'></i> }
                { item.type === 1 && <i className='fa icon-user'></i> }
              </div>
              <div className='item-class-name'>
                { item.name }
              </div>
              <i className='fa icon-angle-right' style={{float:'right'}}></i>
            </div>
           );
        }

      }
    }

    return (
      <div>
        <div className='action-title'>
          <h4>{__('Select Class To Add Lesson', 'schedule')}</h4>
        </div>
        <SearchList {...opts} selectMultiple={false} onSelect={this._onSelectClass} />
        <div className='dock-footer'></div>
      </div>
    );
  }

  _renderLessonForm() {
    const {
      classDetail,
      lesson,
      loading,
    } = this.state;

    const {startDate, studentList, teacherList} = this.props;

    return (
      <div className={classnames('lesson-form', { 'loading': loading, })}>
        <div className='content'>
          <EditLessonForm
            startDate={startDate}
            studentList={studentList}
            teacherList={teacherList}
            lesson={lesson}
            classDetail={classDetail}
            afterSubmit={this.afterSubmit}
          />
        </div>
      </div>
    );
  }

}



export default confirmable(DockBody);



// WEBPACK FOOTER //
// ./src/template/Docks/AddLesson/DockBody.js